import useResource from "./useResource"

export default function useDealAssetsMissingMandatoryFields(dealId) {
  const key = `/deals/${dealId}/missing_asset_stage_fields`
  return useResource({ key })
}
